import { Routes, Route, Navigate } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';

// Pages
import LandingPage from './pages/LandingPage';
import ChatPage from './pages/ChatPage';
import JoinPage from './pages/JoinPage';
import AuthCallback from './pages/AuthCallback';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminLogin from './pages/admin/AdminLogin';
import UsersPage from './pages/admin/UsersPage';
import UserDetail from './pages/UserDetail';
import PromptsPage from './pages/admin/PromptsPage';
import MetricsPage from './pages/admin/MetricsPage';
import ConversationsPage from './pages/admin/ConversationsPage';
import ConversationDetailPage from './pages/admin/ConversationDetailPage';

// Components
import Layout from './components/Layout';
import AdminLayout from './components/admin/AdminLayout';
import LoadingSpinner from './components/common/LoadingSpinner';

function App() {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  // Show loading while MSAL is initializing, but allow auth callback through
  if (inProgress !== InteractionStatus.None && !window.location.pathname.startsWith('/auth-callback')) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <Routes>
      {/* Auth callback - must always be accessible */}
      <Route path="/auth-callback" element={<AuthCallback />} />
      
      {/* Public routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/join" element={<JoinPage />} />
      <Route path="/join/:accessCode" element={<JoinPage />} />
      
      {/* User chat routes */}
      <Route element={<Layout />}>
        <Route 
          path="/chat" 
          element={isAuthenticated ? <ChatPage /> : <Navigate to="/join" replace />} 
        />
        <Route 
          path="/chat/:sessionId" 
          element={isAuthenticated ? <ChatPage /> : <Navigate to="/join" replace />} 
        />
      </Route>

      {/* Admin routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="users/:userId" element={<UserDetail />} />
        <Route path="prompts" element={<PromptsPage />} />
        <Route path="metrics" element={<MetricsPage />} />
        <Route path="conversations" element={<ConversationsPage />} />
        <Route path="conversations/:sessionId" element={<ConversationDetailPage />} />
      </Route>

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
